module.exports = __webpack_public_path__ + "static/media/taimalishan_package.9664d1ad.png";